import React from "react";
import FormLayout from '../FormLayout';
import FormLayoutField from '../FormLayoutField';
import { Field } from 'redux-form'
import { Utils } from '../../services';

/** Class representing a Form layout static text field. */
class StaticTextField extends FormLayoutField {

    constructor(properties) {
        super({
            ...(StaticTextField.getDefaultOptions()),
            ...properties,
        });

        this.type = FormLayout.STATIC_TEXT;
    }

    /**
     * Get this field default options
     */
    static getDefaultOptions() {
        const properties = {
            ...super.getDefaultOptions(),
            content: {

            }
        };
        Utils.langs().forEach(lang => { properties.content[lang] = "";  });

        return properties;
    }

    /**
     * Return the list of options this field handles
     */
    getHandledOptions() {
        return [
            FormLayout.OPTION_WIDTH,
            FormLayout.OPTION_CONTENT,
        ];
    }

    /**
     * Return this field preview as JSX string
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {Bool} inPreview
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     *                 - {Object} resources
     */
    getPreview(props) {
        const { lang } = props;
        return (
            <div className="field-wrapper form-group">
                <div dangerouslySetInnerHTML= {{__html: this.content[lang]}}></div>
            </div>
        );
    }

    /**
     * Render this field label
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     */
    getLabel(props) {
        return null;
    }

    /**
     * Render this field input
     *
     *                 - {Bool} inEdition
     *                 - {Bool} inPreview
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     *                 - {Object} resources
     */
    getInput(props) {
        const { lang } = props;
        return (
            <div className="text-left" dangerouslySetInnerHTML= {{__html: this.content[lang]}}></div>
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'align-justify';
    }
}

export default StaticTextField;
